<template>
  <v-dialog
    v-model="isOpen"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :width="$vuetify.breakpoint.smAndDown ? '' : 500"
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
    v-resize="onResize"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card
      class="d-flex fill-height flex-column"
      :loading="isLoading"
    >
      <div class="sign-pad-wrapper d-flex justify-center align-center fill-height">
        <vue-signature-pad
          v-if="value"
          ref="signaturePad"
          :custom-style="{'line-height': 0}"
        ></vue-signature-pad>
      </div>
      <v-card-actions class="card-actions">
        <v-btn
          large
          text
          @click="isOpen = false"
        >
          {{ $t('取消') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-chip
          v-if="hasPenPower"
          class="ma-2"
          color="green lighten-5"
          label
          text-color="green"
        >
          <v-icon left>
            mdi-draw
          </v-icon>
          手寫板啟用
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          large
          text
          @click="clear"
        >
          {{ $t('清除') }}
        </v-btn>
        <v-btn
          color="primary"
          large
          depressed
          @click="save"
        >
          {{ $t('確認簽名') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';
import PenPower from '../../../libs/pen-power-560';

export default {
  props: {
    value: Boolean,
  },

  components: {
    VueSignaturePad
  },

  data() {
    return {
      isLoading: false,
      hasPenPower: false,
      warningDialog: true,
    }
  },

  computed: {
    isOpen: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      },
    }
  },

  watch: {
    async value() {
      if (this.value) {

        // Fix the scrolling issue on iOS 11
        if (this.$vuetify.breakpoint.smAndDown) {
          document.getElementsByTagName("body")[0].classList.add('no-scroll');
        }

        this.resizeSigaturePad();

        this.hasPenPower = await PenPower.initDevice({
          width: 500,
          height: 380,
          drawing: base64Image => {
            this.$refs.signaturePad.fromDataURL(base64Image);
          }
        });
      } else {
        document.getElementsByTagName("body")[0].classList.remove('no-scroll');
        if (this.hasPenPower) {
          PenPower.uninitDevice();
        }
      }
    },
  },

  methods: {
    onResize() {
      if (!this.$refs.signaturePad) {
        return;
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        document.getElementsByTagName("body")[0].classList.add('no-scroll');
      } else {
        document.getElementsByTagName("body")[0].classList.remove('no-scroll');
      }

      this.resizeSigaturePad();
    },

    resizeSigaturePad() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.signaturePad.resizeCanvas();
        }, 250);
      });
    },

    clear() {
      this.$refs.signaturePad.clearSignature();
      if (this.hasPenPower) {
        PenPower.clear();
      }
    },

    async save() {
      this.isLoading = true;

      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.$emit('sign', null, null);
      } else {
        let blob = await fetch(data).then(res => res.blob());
        this.$emit('sign', data, blob);
      }

      this.clear();
      this.isOpen = false;
      this.isLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.sign-pad-wrapper {
  background: #eee;

  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    height: 400px;
  }
}

.card-actions {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
  }
}

</style>
